//import React, { useState, useEffect } from 'react';
//import { useSelector } from 'react-redux';
//import { IoIosAddCircleOutline } from "react-icons/io";
//import { MdOutlineRemoveRedEye, MdEdit, MdOutlineDeleteForever } from "react-icons/md";
//import { FaRegWindowClose } from "react-icons/fa";
//import { Eye, Pencil, Trash2, Plus, Search } from "lucide-react";
//import Loading from "../../component/Loading/Loading";
//import AlertMsg from '../../component/AlertMsg/AlertMsg';
//import { AiOutlineSortAscending } from "react-icons/ai";
//import Pagination from '../../utils/Pagenation/Pagenation';
//import useAxiosInstance from '../../services/useAxiosInstance';
//import GlassmorphicModal from "../../component/ReusableComponents/GlassmorphicModal";

//const AddAmenity = () => {
//  const axiosInstance = useAxiosInstance();
//  const [amenities, setAmenities] = useState([]);
//  const [showAddForm, setShowAddForm] = useState(false);
//  const [showEditModal, setShowEditModal] = useState(false);
//  const [showDeleteModal, setShowDeleteModal] = useState(false);
//  const [showViewModal, setShowViewModal] = useState(false);
//  const [selectedAmenity, setSelectedAmenity] = useState(null);
//  const [amenityName, setAmenityName] = useState("");
//  const [amenityType, setAmenityType] = useState("");
//  const [amount, setAmount] = useState("");
//  const [lateCharge, setLateCharge] = useState("");
//  const [amenityTypes, setAmenityTypes] = useState([]);
//  const [errors, setErrors] = useState({});
//  const [loading, setLoading] = useState(false);

//  const [alert, setAlert] = useState({ visible: false, message: '', type: '' });

//  const communityId = useSelector((state) => state.auth.communityId);
//  const userId = useSelector((state) => state.auth.userId);

//  useEffect(() => {
//    fetchAmenityTypes();
//    fetchAmenities();
//  }, []);

//  const fetchAmenityTypes = async () => {
//    try {
//      const response = await axiosInstance.get(`/api/public/amenitytype/findByCommunityId/${communityId}`);
//      setAmenityTypes(response.data);
//    } catch (error) {
//      console.error('Error fetching amenity types:', error);
//    }
//  };

//  const fetchAmenities = async () => {
//    setLoading(true);
//    try {
//      const response = await axiosInstance.get(
//        `/api/public/amenity/findByCommunityId/${communityId}`
//      );
//      setAmenities(response.data);
//    } catch (error) {
//      console.error('Error fetching amenities:', error);
//    } finally {
//      setLoading(false);
//    }
//  };


//  const validateForm = () => {
//    let formErrors = {};
//    if (!amenityName) formErrors.amenityName = "Amenity Name is required";
//    if (!amenityType) formErrors.amenityType = "Amenity Type is required";
//    if (!amount) formErrors.amount = "Amount is required";
//    if (!lateCharge) formErrors.lateCharge = "Late Charge is required";
//    setErrors(formErrors);
//    return Object.keys(formErrors).length === 0;
//  };

//  const handleSubmit = async (e) => {
//    e.preventDefault();
//    if (!validateForm()) return;

//    const selectedAmenityType = amenityTypes.find(type => type.id === parseInt(amenityType));
//    const newAmenity = {
//      amenityid: 0,
//      amenitytypeid: selectedAmenityType.id,
//      amount: parseFloat(amount),
//      communityid: communityId,
//      createdbyid: userId,
//      createddate: new Date().toISOString(),
//      latecharge: parseFloat(lateCharge),
//      modifiedbyid: null,
//      modifieddate: new Date().toISOString(),
//      name: amenityName,
//    };

//    try {
//      setLoading(true);
//      const response = await axiosInstance.post(
//        `/api/public/amenity/add`,
//        newAmenity,
//      );
//      console.log('Amenity added successfully:', response.data);
//      setAlert({ visible: true, message: 'Amenity added successfully!', type: 'success' });
//      fetchAmenities();
//      handleCancel();
//    } catch (error) {
//      console.error('Error adding amenity:', error);
//      setAlert({ visible: true, message: 'Error adding amenity. Please try again.', type: 'error' });
//    } finally {
//      setLoading(false);
//    }
//  };

//  const handleCancel = () => {
//    setAmenityName("");
//    setAmenityType("");
//    setAmount("");
//    setLateCharge("");
//    setErrors({});
//    setShowAddForm(false);
//    setShowEditModal(false);
//    setShowViewModal(false);
//  };

//  const handleView = (amenity) => {
//    setSelectedAmenity(amenity);
//    setShowViewModal(true);
//  };

//  const handleEdit = (amenity) => {
//    setSelectedAmenity(amenity);
//    setAmenityName(amenity.name);
//    setShowEditModal(true);
//  };

//  const handleEditSubmit = async (e) => {
//    e.preventDefault();
//    setLoading(true);
//    try {
//      const updatedAmenity = { ...selectedAmenity, name: amenityName };
//      await axiosInstance.put(
//        `/api/public/amenity/update/${selectedAmenity.amenityid}`,
//        updatedAmenity,
//      );
//      console.log('Amenity updated successfully');
//      setAlert({ visible: true, message: 'Amenity updated successfully!', type: 'success' });
//      fetchAmenities();
//      setShowEditModal(false);
//    } catch (error) {
//      console.error('Error updating amenity:', error);
//      setAlert({ visible: true, message: 'Error updating amenity. Please try again.', type: 'error' });
//    } finally {
//      setLoading(false);
//    }
//  };

//  const handleDelete = (amenity) => {
//    setSelectedAmenity(amenity);
//    setShowDeleteModal(true);
//  };

//  const confirmDelete = async () => {
//    setLoading(true);
//    try {
//      await axiosInstance.delete(
//        `/api/public/amenity/delete/${selectedAmenity.amenityid}`
//      );
//      console.log('Amenity deleted successfully');
//      setAlert({ visible: true, message: 'Amenity deleted successfully!', type: 'success' });
//      fetchAmenities();
//      setShowDeleteModal(false);
//    } catch (error) {
//      console.error('Error deleting amenity:', error);
//      setAlert({ visible: true, message: 'Error deleting amenity. Please try again.', type: 'error' });
//    } finally {
//      setLoading(false);
//    }
//  };


//  const closeModal = () => {
//    setSelectedAmenity(null);
//    setShowEditModal(false);
//    setShowDeleteModal(false);
//    setShowViewModal(false);
//    setAmenityName("");
//    setAmenityType("");
//    setAmount("");
//    setLateCharge("");
//    setErrors({});
//    setShowAddForm(false);
//  };

//  const itemsPerPage = 5;
//  const [currentPage, setCurrentPage] = useState(0);
//  const [sortOrder, setSortOrder] = useState('none');

//  const handleSort = () => {
//    setSortOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
//  };

//  const sortedAmenities = [...amenities].sort((a, b) => {
//    if (sortOrder === 'asc') {
//      return a.name.localeCompare(b.name);
//    } else if (sortOrder === 'desc') {
//      return b.name.localeCompare(a.name);
//    }
//    return 0;
//  });

//  const pageCount = Math.ceil(sortedAmenities.length / itemsPerPage);
//  const currentAmenities = sortedAmenities.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

//  // Edit modal footer with action buttons
//  const editModalFooter = (
//    <div className="flex justify-end space-x-2">
//      <button
//        type="button"
//        className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
//        onClick={closeModal}
//      >
//        Cancel
//      </button>
//      <button
//        type="button"
//        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
//        onClick={handleEditSubmit}
//      >
//        Save Changes
//      </button>
//    </div>
//  );

//  // View modal footer with close button
//  const viewModalFooter = (
//    <div className="flex justify-end">
//      <button
//        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
//        onClick={closeModal}
//      >
//        Close
//      </button>
//    </div>
//  );

//  // Delete modal footer with action buttons
//  const deleteModalFooter = (
//    <div className="flex justify-end space-x-2">
//      <button
//        className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
//        onClick={closeModal}
//      >
//        Cancel
//      </button>
//      <button
//        className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
//        onClick={confirmDelete}
//      >
//        Delete
//      </button>
//    </div>
//  );

//  return (
//    <div className="bg-gray-50 min-h-screen md:p-4">
//      {loading && <Loading />}
//      {!loading && (
//        <div className="max-w-7xl mx-auto">
//          {alert.visible && (
//            <AlertMsg
//              message={alert.message}
//              type={alert.type}
//              onClose={() => setAlert({ ...alert, visible: false })}
//            />
//          )}
//          <div className="flex justify-between items-center mb-6">
//            <h1 className="text-2xl font-bold text-gray-800">Amenities</h1>
//            <div className="flex items-center">
//              <button
//                className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md flex items-center gap-2"
//                onClick={() => setShowAddForm(true)}
//              >
//                <Plus size={18} />
//                <span>Add</span>
//              </button>
//            </div>
//          </div>

//          {showAddForm ? (
//            <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
//              <form className="p-4" onSubmit={handleSubmit}>
//                <div className="flex flex-wrap gap-6 mb-6">
//                  <div className="w-full md:w-[calc(50%-1.5rem)]">
//                    <label className="block text-sm font-medium text-gray-700 mb-1">
//                      Amenity Type <span className="text-red-500">*</span>
//                    </label>
//                    <select
//                      id="amenityType"
//                      value={amenityType}
//                      onChange={(e) => setAmenityType(e.target.value)}
//                      className={`w-full rounded-md border ${errors.amenityType ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
//                    >
//                      <option value="">Select Amenity Type</option>
//                      {amenityTypes.filter((amenityType) => amenityType.communityId === communityId).map((type) => (
//                        <option key={type.id} value={type.id}>
//                          {type.name}
//                        </option>
//                      ))}
//                    </select>
//                    {errors.amenityType && <p className="text-red-500 text-xs mt-1">{errors.amenityType}</p>}
//                  </div>

//                  <div className="w-full md:w-[calc(50%-1.5rem)]">
//                    <label className="block text-sm font-medium text-gray-700 mb-1">
//                      Amenity Name <span className="text-red-500">*</span>
//                    </label>
//                    <input
//                      type="text"
//                      id="amenityName"
//                      value={amenityName}
//                      onChange={(e) => setAmenityName(e.target.value)}
//                      className={`w-full rounded-md border ${errors.amenityName ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
//                    />
//                    {errors.amenityName && <p className="text-red-500 text-xs mt-1">{errors.amenityName}</p>}
//                  </div>

//                  <div className="w-full md:w-[calc(50%-1.5rem)]">
//                    <label className="block text-sm font-medium text-gray-700 mb-1">
//                      Amount (Set an Amenity fee) <span className="text-red-500">*</span>
//                    </label>
//                    <input
//                      type="number"
//                      id="amount"
//                      value={amount}
//                      onChange={(e) => setAmount(e.target.value)}
//                      className={`w-full rounded-md border ${errors.amount ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
//                    />
//                    {errors.amount && <p className="text-red-500 text-xs mt-1">{errors.amount}</p>}
//                  </div>

//                  <div className="w-full md:w-[calc(50%-1.5rem)]">
//                    <label className="block text-sm font-medium text-gray-700 mb-1">
//                      Late Charge Amount <span className="text-red-500">*</span>
//                    </label>
//                    <input
//                      type="number"
//                      id="lateCharge"
//                      value={lateCharge}
//                      onChange={(e) => setLateCharge(e.target.value)}
//                      className={`w-full rounded-md border ${errors.lateCharge ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
//                    />
//                    {errors.lateCharge && <p className="text-red-500 text-xs mt-1">{errors.lateCharge}</p>}
//                  </div>
//                </div>

//                <div className="flex justify-between items-center">
//                  <div className="text-sm text-red-500">* indicates required field</div>
//                  <div className="flex gap-2">
//                    <button
//                      type="button"
//                      className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
//                      onClick={handleCancel}
//                    >
//                      Cancel
//                    </button>
//                    <button
//                      type="submit"
//                      className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
//                    >
//                      Submit
//                    </button>
//                  </div>
//                </div>
//              </form>
//            </div>
//          ) : (
//            <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">


//              <div className="overflow-x-auto">
//                <table className="min-w-full divide-y divide-gray-200">
//                  <thead className="bg-blue-400">
//                    <tr>
//                      <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Name  <button
//                        onClick={handleSort}
//                      >
//                       <AiOutlineSortAscending className="inline ml-1" />
//                      </button></th>
//                      <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Type</th>
//                      <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Amount</th>
//                      <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Late Charge</th>
//                      <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Action</th>
//                    </tr>
//                  </thead>
//                  <tbody className="bg-white divide-y divide-gray-200">
//                    {currentAmenities.length === 0 ? (
//                      <tr>
//                        <td colSpan="5" className="px-6 py-4 text-center text-sm text-gray-500">No Data Found</td>
//                      </tr>
//                    ) : (
//                      currentAmenities.map((amenity) => (
//                        <tr key={amenity.amenityid} className="hover:bg-gray-50">
//                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{amenity.name}</td>
//                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{amenity.amenitytypename}</td>
//                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{amenity.amount.toFixed(2)}</td>
//                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{amenity.latecharge.toFixed(2)}</td>
//                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium flex gap-3">
//                            <button
//                              className="text-blue-500 hover:text-blue-700"
//                              onClick={() => handleView(amenity)}
//                              title="View Amenity"
//                            >
//                              <Eye size={18} />
//                            </button>
//                            <button
//                              className="text-gray-500 hover:text-gray-700"
//                              onClick={() => handleEdit(amenity)}
//                              title="Edit Amenity"
//                            >
//                              <Pencil size={18} />
//                            </button>
//                            <button
//                              className="text-red-500 hover:text-red-700"
//                              onClick={() => handleDelete(amenity)}
//                              title="Delete Amenity"
//                            >
//                              <Trash2 size={18} />
//                            </button>
//                          </td>
//                        </tr>
//                      ))
//                    )}
//                  </tbody>
//                </table>
//              </div>

//              <div className="bg-gray-50 px-6 py-3 flex items-center justify-between border-t border-gray-200">
//                <div className="text-sm text-gray-700">
//                  Page {currentPage + 1} of {pageCount}
//                </div>
//                <div className="flex-1 flex justify-end">
//                  <Pagination
//                    currentPage={currentPage}
//                    pageCount={pageCount}
//                    setCurrentPage={setCurrentPage}
//                  />
//                </div>
//              </div>
//            </div>
//          )}

//          {/* View Modal using GlassmorphicModal */}
//          <GlassmorphicModal
//            isOpen={showViewModal}
//            onClose={closeModal}
//            title="View Amenity Details"
//            size="md"
//            footer={viewModalFooter}
//          >
//            {selectedAmenity && (
//              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                <div>
//                  <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
//                  <input
//                    type="text"
//                    value={selectedAmenity.name}
//                    readOnly
//                    className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
//                  />
//                </div>
//                <div>
//                  <label className="block text-sm font-medium text-gray-700 mb-1">Type</label>
//                  <input
//                    type="text"
//                    value={selectedAmenity.amenitytypename}
//                    readOnly
//                    className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
//                  />
//                </div>
//                <div>
//                  <label className="block text-sm font-medium text-gray-700 mb-1">Amount</label>
//                  <input
//                    type="text"
//                    value={selectedAmenity.amount.toFixed(2)}
//                    readOnly
//                    className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
//                  />
//                </div>
//                <div>
//                  <label className="block text-sm font-medium text-gray-700 mb-1">Late Charge</label>
//                  <input
//                    type="text"
//                    value={selectedAmenity.latecharge.toFixed(2)}
//                    readOnly
//                    className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
//                  />
//                </div>
//              </div>
//            )}
//          </GlassmorphicModal>

//          {/* Edit Modal using GlassmorphicModal */}
//          <GlassmorphicModal
//            isOpen={showEditModal}
//            onClose={closeModal}
//            title="Edit Amenity"
//            size="md"
//            footer={editModalFooter}
//          >
//            <div>
//              <label className="block text-sm font-medium text-gray-700 mb-1">
//                Amenity Name <span className="text-red-500">*</span>
//              </label>
//              <input
//                type="text"
//                id="editAmenityName"
//                value={amenityName}
//                onChange={(e) => setAmenityName(e.target.value)}
//                className={`w-full rounded-md border ${errors.amenityName ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
//              />
//              {errors.amenityName && <p className="text-red-500 text-xs mt-1">{errors.amenityName}</p>}
//            </div>
//          </GlassmorphicModal>

//          {/* Delete Modal using GlassmorphicModal */}
//          <GlassmorphicModal
//            isOpen={showDeleteModal}
//            onClose={closeModal}
//            title="Confirm Delete"
//            size="sm"
//            footer={deleteModalFooter}
//          >
//            <p className="text-gray-700">
//              Are you sure you want to delete this amenity? This action cannot be undone.
//            </p>
//          </GlassmorphicModal>
//        </div>
//      )}
//    </div>
//  );
//};

//export default AddAmenity;

import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { IoIosAddCircleOutline } from "react-icons/io";
import { MdOutlineRemoveRedEye, MdEdit, MdOutlineDeleteForever } from "react-icons/md";
import { FaRegWindowClose } from "react-icons/fa";
import { Eye, Pencil, Trash2, Plus, Search } from "lucide-react";
import Loading from "../../component/Loading/Loading";
import AlertMsg from '../../component/AlertMsg/AlertMsg';
import { AiOutlineSortAscending } from "react-icons/ai";
import Pagination from '../../utils/Pagenation/Pagenation';
import useAxiosInstance from '../../services/useAxiosInstance';
import GlassmorphicModal from "../../component/ReusableComponents/GlassmorphicModal";

const AddAmenity = () => {
    const axiosInstance = useAxiosInstance();
    const [amenities, setAmenities] = useState([]);
    const [showAddForm, setShowAddForm] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedAmenity, setSelectedAmenity] = useState(null);
    const [amenityName, setAmenityName] = useState("");
    const [amenityType, setAmenityType] = useState("");
    const [amount, setAmount] = useState("");
    const [lateCharge, setLateCharge] = useState("");
    const [amenityTypes, setAmenityTypes] = useState([]);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [activeStatus, setActiveStatus] = useState(true);
    const [alert, setAlert] = useState({ visible: false, message: '', type: '' });

    const communityId = useSelector((state) => state.auth.communityId);
    const userId = useSelector((state) => state.auth.userId);

    useEffect(() => {
        fetchAmenityTypes();
        fetchAmenities();
    }, []);

    const fetchAmenityTypes = async () => {
        try {
            const response = await axiosInstance.get(`/api/public/amenitytype/findByCommunityId/${communityId}`);
            setAmenityTypes(response.data);
        } catch (error) {
            console.error('Error fetching amenity types:', error);
        }
    };

    const fetchAmenities = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get(
                `/api/public/amenity/findByCommunityId/${communityId}`
            );
            setAmenities(response.data);
        } catch (error) {
            console.error('Error fetching amenities:', error);
        } finally {
            setLoading(false);
        }
    };

    const validateForm = () => {
        let formErrors = {};
        if (!amenityName) formErrors.amenityName = "Amenity Name is required";
        if (!amenityType) formErrors.amenityType = "Amenity Type is required";
        if (!amount) formErrors.amount = "Amount is required";
        if (!lateCharge) formErrors.lateCharge = "Late Charge is required";
        setErrors(formErrors);
        return Object.keys(formErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        const selectedAmenityType = amenityTypes.find(type => type.id === parseInt(amenityType));
        const newAmenity = {
            amenityId: 0,
            amenityTypeId: selectedAmenityType.id,
            amount: parseFloat(amount),
            communityId: communityId,
            createdById: userId,
            createdDate: new Date().toISOString(),
            latecharge: parseFloat(lateCharge),
            modifiedById: userId,
            modifiedDate: new Date().toISOString(),
            name: amenityName,
            activeStatus: true,
        };

        console.log(newAmenity);

        try {
            setLoading(true);
            const response = await axiosInstance.post(
                `/api/public/amenity/add`,
                newAmenity,
            );
            console.log('Amenity added successfully:', response.data);
            setAlert({ visible: true, message: 'Amenity added successfully!', type: 'success' });
            fetchAmenities();
            handleCancel();
        } catch (error) {
            console.error('Error adding amenity:', error);
            setAlert({ visible: true, message: 'Error adding amenity. Please try again.', type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        setAmenityName("");
        setAmenityType("");
        setAmount("");
        setLateCharge("");
        setErrors({});
        setShowAddForm(false);
        setShowEditModal(false);
        setShowViewModal(false);
    };

    const handleView = (amenity) => {
        setSelectedAmenity(amenity);
        setShowViewModal(true);
    };

    const handleEdit = (amenity) => {
        setSelectedAmenity(amenity);
        setAmenityName(amenity.name);
        setAmenityType(amenity.amenitytypeid);
        setAmount(amenity.amount !== null ? amenity.amount.toString() : "");
        setLateCharge(amenity.latecharge !== null ? amenity.latecharge.toString() : "");
        setActiveStatus(amenity.activeStatus);
        setShowEditModal(true);
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            // Prepare the updated amenity object with all fields
            const updatedAmenity = {
                ...selectedAmenity,
                name: amenityName,
                amenityTypeId: parseInt(amenityType),
                amount: parseFloat(amount),
                lateCharge: parseFloat(lateCharge),
                activeStatus: activeStatus,
                modifiedById: userId,
                modifiedDate: new Date().toISOString(),
                createdById: userId,
                createdDate: new Date().toISOString(),
                communityId: communityId,
            };

            // Debug: Print what we're about to send
            console.log("Payload being sent to API:", JSON.stringify(updatedAmenity, null, 2));
            console.log("Endpoint:", `/api/public/amenity/update/${selectedAmenity.amenityid}`);

            const response = await axiosInstance.put(
                `/api/public/amenity/update/${selectedAmenity.amenityid}`,
                updatedAmenity
            );

            // Debug: Print the API response
            console.log("API Response:", response.data);

            setAlert({ visible: true, message: 'Amenity updated successfully!', type: 'success' });

            // Debug: Before fetching updated data
            console.log("Fetching updated amenities list...");
            await fetchAmenities();

            setShowEditModal(false);
        } catch (error) {
            console.error('Error updating amenity:', error);
            console.log("Error details:", {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status
            });
            setAlert({ visible: true, message: 'Error updating amenity. Please try again.', type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = (amenity) => {
        setSelectedAmenity(amenity);
        setShowDeleteModal(true);
    };

    const confirmDelete = async () => {
        setLoading(true);
        try {
            await axiosInstance.delete(
                `/api/public/amenity/delete/${selectedAmenity.amenityid}`
            );
            console.log('Amenity deleted successfully');
            setAlert({ visible: true, message: 'Amenity deleted successfully!', type: 'success' });
            fetchAmenities();
            setShowDeleteModal(false);
        } catch (error) {
            console.error('Error deleting amenity:', error);
            setAlert({ visible: true, message: 'Error deleting amenity. Please try again.', type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const closeModal = () => {
        setSelectedAmenity(null);
        setShowEditModal(false);
        setShowDeleteModal(false);
        setShowViewModal(false);
        setAmenityName("");
        setAmenityType("");
        setAmount("");
        setLateCharge("");
        setErrors({});
        setShowAddForm(false);
    };

    const itemsPerPage = 5;
    const [currentPage, setCurrentPage] = useState(0);
    const [sortOrder, setSortOrder] = useState('none');

    const handleSort = () => {
        setSortOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
    };

    const sortedAmenities = [...amenities].sort((a, b) => {
        if (sortOrder === 'asc') {
            return a.name.localeCompare(b.name);
        } else if (sortOrder === 'desc') {
            return b.name.localeCompare(a.name);
        }
        return 0;
    });

    const pageCount = Math.ceil(sortedAmenities.length / itemsPerPage);
    const currentAmenities = sortedAmenities.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

    // Edit modal footer with action buttons
    const editModalFooter = (
        <div className="flex justify-end space-x-2">
            <button
                type="button"
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                onClick={closeModal}
            >
                Cancel
            </button>
            <button
                type="button"
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                onClick={handleEditSubmit}
            >
                Save Changes
            </button>
        </div>
    );

    // View modal footer with close button
    const viewModalFooter = (
        <div className="flex justify-end">
            <button
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                onClick={closeModal}
            >
                Close
            </button>
        </div>
    );

    // Delete modal footer with action buttons
    const deleteModalFooter = (
        <div className="flex justify-end space-x-2">
            <button
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                onClick={closeModal}
            >
                Cancel
            </button>
            <button
                className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
                onClick={confirmDelete}
            >
                Delete
            </button>
        </div>
    );

    return (
        <div className="bg-gray-50 min-h-screen md:p-4">
            {loading && <Loading />}
            {!loading && (
                <div className="max-w-7xl mx-auto">
                    {alert.visible && (
                        <AlertMsg
                            message={alert.message}
                            type={alert.type}
                            onClose={() => setAlert({ ...alert, visible: false })}
                        />
                    )}
                    <div className="flex justify-between items-center mb-6">
                        <h1 className="text-2xl font-bold text-gray-800">Amenities</h1>
                        <div className="flex items-center">
                            <button
                                className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md flex items-center gap-2"
                                onClick={() => setShowAddForm(true)}
                            >
                                <Plus size={18} />
                                <span>Add</span>
                            </button>
                        </div>
                    </div>

                    {showAddForm ? (
                        <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
                            <form className="p-4" onSubmit={handleSubmit}>
                                <div className="flex flex-wrap gap-6 mb-6">
                                    <div className="w-full md:w-[calc(50%-1.5rem)]">
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Amenity Type <span className="text-red-500">*</span>
                                        </label>
                                        <select
                                            id="amenityType"
                                            value={amenityType}
                                            onChange={(e) => setAmenityType(e.target.value)}
                                            className={`w-full rounded-md border ${errors.amenityType ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                        >
                                            <option value="">Select Amenity Type</option>
                                            {amenityTypes.filter((amenityType) => amenityType.communityId === communityId).map((type) => (
                                                <option key={type.id} value={type.id}>
                                                    {type.name}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.amenityType && <p className="text-red-500 text-xs mt-1">{errors.amenityType}</p>}
                                    </div>

                                    <div className="w-full md:w-[calc(50%-1.5rem)]">
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Amenity Name <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            id="amenityName"
                                            value={amenityName}
                                            maxLength={100}
                                            onChange={(e) => setAmenityName(e.target.value)}
                                            className={`w-full rounded-md border ${errors.amenityName ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                        />
                                        {errors.amenityName && <p className="text-red-500 text-xs mt-1">{errors.amenityName}</p>}
                                    </div>

                                    <div className="w-full md:w-[calc(50%-1.5rem)]">
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Amount (Set an Amenity fee) <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            id="amount"
                                            value={amount}
                                            maxLength={10}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                // Only update if value is empty (to allow clearing) or a non-negative number
                                                if (value === '' || parseInt(value) >= 0) {
                                                    setAmount(value);
                                                }
                                            }}
                                            className={`w-full rounded-md border ${errors.amount ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                            min="0"
                                        />
                                        {errors.amount && <p className="text-red-500 text-xs mt-1">{errors.amount}</p>}
                                    </div>

                                    <div className="w-full md:w-[calc(50%-1.5rem)]">
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Late Charge Amount <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            id="lateCharge"
                                            value={lateCharge}
                                            maxLength={10}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setLateCharge(value === "" ? value : Math.max(0, parseFloat(value) || 0));
                                            }}
                                            className={`w-full rounded-md border ${errors.lateCharge ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                        />
                                        {errors.lateCharge && <p className="text-red-500 text-xs mt-1">{errors.lateCharge}</p>}
                                    </div>
                                </div>

                                <div className="flex justify-between items-center">
                                    <div className="text-sm text-red-500">* indicates required field</div>
                                    <div className="flex gap-2">
                                        <button
                                            type="button"
                                            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                                            onClick={handleCancel}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    ) : (
                        <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
                            <div className="overflow-x-auto">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-blue-400">
                                        <tr>
                                            <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Name  <button
                                                onClick={handleSort}
                                            >
                                                <AiOutlineSortAscending className="inline ml-1" />
                                            </button></th>
                                            <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Type</th>
                                            <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Amount</th>
                                            <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Late Charge</th>
                                            <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Active Status</th>
                                            <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                        {currentAmenities.length === 0 ? (
                                            <tr>
                                                <td colSpan="6" className="px-6 py-4 text-center text-sm text-gray-500">No Data Found</td>
                                            </tr>
                                        ) : (
                                            currentAmenities.map((amenity) => (
                                                <tr key={amenity.amenityid} className="hover:bg-gray-50">
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-left">{amenity.name}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-left">{amenity.amenitytypename}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-left">{amenity.amount ? amenity.amount.toFixed(2) : '0.00'}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-left">{amenity.latecharge ? amenity.latecharge.toFixed(2) : '0.00'}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-left">
                                                        <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${amenity.activeStatus
                                                                ? 'text-green-800 bg-green-100'
                                                                : 'text-red-800 bg-red-100'
                                                            }`}>
                                                            {amenity.activeStatus ? "Active" : "Inactive"}
                                                        </span>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium flex gap-3">
                                                        <button
                                                            className="text-blue-500 hover:text-blue-700"
                                                            onClick={() => handleView(amenity)}
                                                            title="View Amenity"
                                                        >
                                                            <Eye size={18} />
                                                        </button>
                                                        <button
                                                            className="text-gray-500 hover:text-gray-700"
                                                            onClick={() => handleEdit(amenity)}
                                                            title="Edit Amenity"
                                                        >
                                                            <Pencil size={18} />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            <div className="bg-gray-50 px-6 py-3 flex items-center justify-between border-t border-gray-200">
                                <div className="text-sm text-gray-700">
                                    Page {currentPage + 1} of {pageCount}
                                </div>
                                <div className="flex-1 flex justify-end">
                                    <Pagination
                                        currentPage={currentPage}
                                        pageCount={pageCount}
                                        setCurrentPage={setCurrentPage}
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    {/* View Modal using GlassmorphicModal */}
                    <GlassmorphicModal
                        isOpen={showViewModal}
                        onClose={closeModal}
                        title="View Amenity Details"
                        size="md"
                        footer={viewModalFooter}
                    >
                        {selectedAmenity && (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                                    <input
                                        type="text"
                                        value={selectedAmenity.name}
                                        readOnly
                                        className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Type</label>
                                    <input
                                        type="text"
                                        value={selectedAmenity.amenitytypename}
                                        readOnly
                                        className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Amount</label>
                                    <input
                                        type="text"
                                        value={selectedAmenity.amount ? selectedAmenity.amount.toFixed(2) : '0.00'}
                                        readOnly
                                        className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Late Charge</label>
                                    <input
                                        type="text"
                                        value={selectedAmenity.latecharge ? selectedAmenity.latecharge.toFixed(2) : '0.00'}
                                        readOnly
                                        className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
                                    />
                                </div>
                            </div>
                        )}
                    </GlassmorphicModal>

                    {/* Edit Modal using GlassmorphicModal */}
                    <GlassmorphicModal
                        isOpen={showEditModal}
                        onClose={closeModal}
                        title="Edit Amenity"
                        size="lg"
                        footer={editModalFooter}
                    >
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Amenity Type <span className="text-red-500">*</span>
                                </label>
                                <select
                                    id="editAmenityType"
                                    value={amenityType}
                                    onChange={(e) => setAmenityType(e.target.value)}
                                    className={`w-full rounded-md border ${errors.amenityType ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                >
                                    <option value="">Select Amenity Type</option>
                                    {amenityTypes.filter((amenityType) => amenityType.communityId === communityId).map((type) => (
                                        <option key={type.id} value={type.id}>
                                            {type.name}
                                        </option>
                                    ))}
                                </select>
                                {errors.amenityType && <p className="text-red-500 text-xs mt-1">{errors.amenityType}</p>}
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Amenity Name <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="editAmenityName"
                                    maxLength={100}
                                    value={amenityName}
                                    onChange={(e) => setAmenityName(e.target.value)}
                                    className={`w-full rounded-md border ${errors.amenityName ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                />
                                {errors.amenityName && <p className="text-red-500 text-xs mt-1">{errors.amenityName}</p>}
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Amount <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="number"
                                    id="editAmount"
                                    value={amount}
                                    maxLength={10}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (value === '' || parseInt(value) >= 0) {
                                            setAmount(value);
                                        }
                                    }}
                                    className={`w-full rounded-md border ${errors.amount ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                    min="0"
                                />
                                {errors.amount && <p className="text-red-500 text-xs mt-1">{errors.amount}</p>}
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Late Charge Amount <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="number"
                                    id="editLateCharge"
                                    maxLength={10}
                                    value={lateCharge}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setLateCharge(value === "" ? value : Math.max(0, parseFloat(value) || 0));
                                    }}
                                    className={`w-full rounded-md border ${errors.lateCharge ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                                />
                                {errors.lateCharge && <p className="text-red-500 text-xs mt-1">{errors.lateCharge}</p>}
                            </div>

                            <div className="md:col-span-2">
                                <label className="block text-sm font-medium text-gray-700 mb-3">Active Status:</label>
                                <div className="flex space-x-6">
                                    <label className="flex items-center">
                                        <input
                                            type="radio"
                                            name="activeStatus"
                                            checked={activeStatus}
                                            onChange={() => setActiveStatus(true)}
                                            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                                        />
                                        <span className="ml-2 text-sm text-gray-700">Active</span>
                                    </label>
                                    <label className="flex items-center">
                                        <input
                                            type="radio"
                                            name="activeStatus"
                                            checked={!activeStatus}
                                            onChange={() => setActiveStatus(false)}
                                            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                                        />
                                        <span className="ml-2 text-sm text-gray-700">Inactive</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </GlassmorphicModal>

                    {/* Delete Modal using GlassmorphicModal */}
                    <GlassmorphicModal
                        isOpen={showDeleteModal}
                        onClose={closeModal}
                        title="Confirm Delete"
                        size="sm"
                        footer={deleteModalFooter}
                    >
                        <p className="text-gray-700">
                            Are you sure you want to delete this amenity? This action cannot be undone.
                        </p>
                    </GlassmorphicModal>
                </div>
            )}
        </div>
    );
};

export default AddAmenity;